import API from './API';

const path = `relatorios/acompanhamento`;

const AcompanhamentoService = {

    visaoGeral: async filters => await API.filters(`${path}/visao-geral`, filters),

    porRegiao: async filters => await API.filters(`${path}/por-regiao`, filters),
    exportPorRegiao: async filters => await API.export(`${path}/por-regiao`, filters),

    evolucao: async filters => await API.filters(`${path}/evolucao`, filters),

    checks: async filters => await API.filters(`${path}/checks`, filters),
}

export default AcompanhamentoService;
